export const emptyGoalListMessage = 'Your goal list is empty.';
export const emptyAssigneesList = "The assignees list for this goal is empty.";
export const accomplishmentEmptyList = "No accomplishments available this week.";
export const planEmptyList = "No tasks available this week.";
export const challengesEmptyList = "No challenges reported this week.";
export const comingUpEmptyList = "No tasks available next week.";
export const allWSItemsEmptyList = "The list of weekly statuses is empty.";
export const emptyFilterWSList = "No results available";
export const emptyActivityList = "No activity detected."
export const emptyPostsList = "No posts yet.";
export const emptyFormsList = "No form templates available.";
export const emptyPulsePointList = "No results available";
export const emptyReviewList = "No users reviewed.";
export const emptyReceivedReviewList = "No available received reviews.";
export const inactiveModule = "This module is not activated!";
export const notStartedReviewPeriod = "The review period is not started!";
export const notSelectedFrequency = "The review period frequency is not selected!";
export const emptyFormFields = "Form template doesn't have fields!";
export const emptyCheckInsList = "No results are available․";
